module.exports = __webpack_public_path__ + "img/res5.233818c9.png";